import React from "react";
export const options = {
    columns: [
        { id: 1, name: '', label: '', sortable: false, },
        { id: 2, name: 'campaignId', label: 'CAMAPAIGN ID', sortable: false, component: (row) => <div>{row.marginDetails && row.marginDetails.length > 0 && row.marginDetails[0].campaignId}</div> },
        { id: 3, name: 'advertiserId', label: 'ADVERTISER', sortable: false, type: 'string' },
        {
            id: 4, name: 'campaignName', label: 'CAMPAIGN NAME', sortable: true, type: 'date',
            //  component: (row) => moment(row.txnDateTime).format('DD-MMM-YY')
        },
        { id: 5, name: 'platformId', label: 'PLATFORM', sortable: true, type: 'string' },
        { id: 6, name: 'platformCampaignName', label: 'PLATFORM CAMP NAME', sortable: true, type: 'string' },
        { id: 7, name: 'status', label: 'STATUS', sortable: true, type: 'string', component: (row) => <div>{row.campaignStatus == "1" ? "Active" : row.campaignStatus == "2" ? "Paused" : row.campaignStatus == "0" ? "Inactive" : ''}</div> },
        { id: 8, name: 'feeModel', label: 'FEE MODEL', sortable: true, type: 'string', component: (row) => <div>{row.feeModel == "0" ? "CPM" : row.feeModel == "1" ? "CPC" : row.feeModel == "2" ? "CPA" : row.feeModel == "3" ? "Advertiser Spend" : ''}</div> },
        { id: 9, name: 'feeValue', label: 'FEE VALUE', sortable: false, type: 'number', },
        // { id: 3, name: 'strategyName', label: 'STRATEGY  NAME', sortable: true, type: 'string' },
        // { id: 4, name: 'feeType', label: 'FEE TYPE', sortable: true, type: 'number', component: (row) => <div>{row.feeType == "0" ? "Fixed" : "Percentage"}</div> },
        // { id: 4, name: 'txnCreditAmount', label: 'UPDATE PLATFORM', sortable: true, type: 'number' },
        // { id: 5, name: 'txnCurrentBalance', label: 'ADD ON', sortable: false, type: 'number', },
    ],
    keyCol: 'ioNo',
    actionName: 'Actions',
    actions: [
        {
            type: 'edit',
            text: '',
            icon: 'ti ti-pencil color-beki',
            tooltip: 'Edit',
            iconType: 'new'
        },
    ],
    recActive: false,
    actionsThead: true,
    sortable: true,
    dateType: true,
    defaultSortParams: {
        sortBy: 'txnDateTime',
        sortOrder: 'desc'
    },
    paging: true,
    defaultPagingParams: {
        pageSize: 25
    }
};

export const formFields = {
    search: {
        key: 'search',
        type: 'string',
        label: '',
        displayLayout: 'col-md-12',
        placeholder: "Search on Campaign Name"
    }
};